<template>
  <v-app>
    <Header :title="breadcrumb"></Header>
    <v-container fluid>
      <v-row justify="start">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card class="pa-6">
            <v-form ref="form" lazy-validation>
              <v-text-field
                  label="Name"
                  v-model="form.name"
                  :rules="[() => !!form.name || 'This field is required']"
                  :error-messages="errorMessages"
                  required
              ></v-text-field>



              <v-select
                  :items="getTimeSlots"
                  label="Duration"
                  v-model="form.durationInMint"
                  class="mt-5"
                  :rules="[() => !!form.durationInMint || 'This field is required']"
                  :error-messages="errorMessages"
              ></v-select>



              <v-color-picker
                  label="Color"
                  v-model="form.color"
                  hide-mode-switch
                  hide-inputs
                  class="mb-4"
              ></v-color-picker>

              <v-row class="mt-5">
                <v-col cols="12" sm="6">
                  <v-btn
                      @click="createAppointmentTypeService"
                      block
                      dark
                      color="#ae1431"
                      elevation="0"
                  >
                    Update user
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                      block
                      outlined
                      elevation="0"
                      :to="{ name: 'AppointmentTypeServiceView' }"
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";
import Header from "@/components/Header.vue";

export default {
  props: ["id"],
  data() {
    return {
      breadcrumb: 'Create New Appointment Type',
      errorMessages: "",
      departments: [],
      users: [],
      form: {
        name: null,
        durationInMint: null,
        color: null,
        type: 'BLOCKING'
      },
    };
  },
  components: {Header},

  methods: {


    async createAppointmentTypeService() {
      if (this.$refs.form.validate()) {
        this.form.color=this.form.color.hex;

        await this.$store.dispatch("createAppointmentTypeService", this.form);
        // await this.$store.dispatch("fetchAllUsers");
        this.$router.back();
        // console.log(this.formUser.userType);
      } else {
        console.log(this.$refs.form.validate());
        // alert("Please fill out the required fields.");
      }
    },


  },

  mounted() {
  },
  computed:{
    getTimeSlots(){
      const timeSlots = [];

      for(let i=5;i<=480;i=i+5){
        timeSlots.push(i);
      }
      return timeSlots;
    }
  }
};
</script>

<style scoped>
.v-card__title {
  background-color: #a8e3e1;
}
</style>
